import React from "react";
import moment from "moment";
import Fares from "./Fares";
import "./MultiplePriceCard.css"

function Index({ flight, onClick, selected, appId, setAppId, fullSelection }) {
  let { details, operator, fares, remaining, segments } = flight;

  //Finding the Retail fare
  let retailFare = 0;
  fares.forEach((fare) => {
    if (fare.type === "RETAIL") {
      retailFare = fare.adult.publishedFare;
    }
  });

  const startTime = moment(details.departure);
  const endTime = moment(details.arrival);
  const duration = moment.duration(endTime.diff(startTime));
  const hours = parseInt(duration.asHours());
  const minutes = parseInt(duration.asMinutes()) % 60;

  function formatTerminal(terminalValue) {
    if (typeof terminalValue !== 'string' || !terminalValue) return '';
  
    const lowerValue = terminalValue.toLowerCase();
    
    if (!lowerValue.includes("terminal")) {
      return `Terminal - ${terminalValue}`;
    }
  
    return terminalValue;
  }
  
  

  return (
    <>
      <div
        className="FadeInUp-Effect bg-white rounded-4 shadow-sm mt-3 overflow-hidden"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="flight-container">
          <div className="flight-operator-section">
            <div className="flight-operator-logo-wrapper">
              <img
                alt="Airline_logo"
                className="flight-logo"
                src={operator?.logo}
              />
              <div className="flight-operator-info">
                <p className="flight-operator-name">{operator?.name}</p>
                <p className="flight-flight-code">
                  {operator?.code}-{operator?.number}
                </p>
              </div>
            </div>
          </div>

          <div className="flight-details-section">
            <div className="flight-time-column flight-departure">
              <div className="flight-time-info">
                <p className="flight-time">
                  {moment(details?.departure).format("HH:mm")}
                </p>
                <p className="flight-date">
                  {moment(details?.departure).format("DD MMM")}
                </p>
              </div>
              <div className="flight-ground-info">
                <p className="flight-airport">
                  {segments[0]?.departure?.airport}
                </p>
                <p className="flight-terminal">
                  {formatTerminal(segments[0]?.departure?.terminal)}
                </p>
              </div>
            </div>

            <div className="flight-duration-column">
              <p className="flight-duration">
                {hours}h {minutes.toFixed(0)}m
              </p>
              <p className="flight-dash-line" />
              <p className="flight-stops">
                {segments?.length > 1
                  ? `${segments?.length - 1} Stop`
                  : "Non-Stop"}
              </p>
            </div>

            <div className="flight-time-column flight-arrival">
              <div className="flight-time-info">
                <p className="flight-time">
                  {moment(details?.arrival).format("HH:mm")}
                </p>
                <p className="flight-date">
                  {moment(details?.arrival).format("DD MMM")}
                </p>
              </div>
              <div className="flight-ground-info">
                <p className="flight-airport">
                  {segments[segments?.length - 1]?.arrival?.airport}
                </p>
                <p className="flight-terminal">
                  {formatTerminal(segments[segments?.length - 1]?.arrival?.terminal)}
                </p>
              </div>
            </div>
          </div>
        </div>
        <Fares
          appId={appId}
          fullSelection={fullSelection}
          setAppId={setAppId}
          selected={selected}
          onClick={onClick}
          fares={fares}
          flight={flight}
          retailFare={retailFare}
        />
      </div>
    </>
  );
}

export default Index;
